import Imunizacao from '../pages/Imunizacao/Index'
import VacinaIdadeCerta from '../pages/Imunizacao/VacinaIdadeCerta/Index'

export default [
  {
    path: '/imunizacao',
    component: Imunizacao,
  },
  {
    path: '/vacina-idade-certa',
    component: VacinaIdadeCerta,
  },
  {
    path: '/divergencias-vacinas',
    component: () => import('@/pages/Imunizacao/DivergenciasVacinas/Index.vue'),
  },
  {
    path: '/importar-vacinas',
    component: () => import('@/pages/Imunizacao/ImportarVacinas/Index.vue'),
  },
  {
    path: '/divergencias-vacinas/vacinas-nao-enviadas',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-nao-enviadas',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/d3-antes-6',
    component: () =>
      import('@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/Template.vue'),
    children: [
      {
        path: '/divergencias-vacinas/d3-antes-6',
        component: () =>
          import('@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/Index.vue'),
      },
    ],
  },
  {
    path: '/vacinas-nascimento-divergente',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-nascimento-divergente',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/vacinas-sem-cadastro',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-sem-cadastro',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/vacinas-antes-nascimento',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/Template.vue'
      ),
    children: [
      {
        path: '/divergencias-vacinas/vacinas-antes-nascimento',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/faltosos-vacinas-0-15-anos',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Template.vue'
      ),
    children: [
      {
        path: '/faltosos-vacinas-0-15-anos',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/hpv-quadrivalente',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Template.vue'
      ),
    children: [
      {
        path: '/hpv-quadrivalente',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/acwy',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Acwy/Template.vue'),
    children: [
      {
        path: '/acwy',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/Acwy/Index.vue'),
      },
    ],
  },
  {
    path: '/covid19-infantil',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Template.vue'
      ),
    children: [
      {
        path: '/covid19-infantil',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/vacina-dengue',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Template.vue'),
    children: [
      {
        path: '/vacina-dengue',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Index.vue'),
      },
    ],
  },
  {
    path: '/campanha-gripe',
    component: () => import('@/pages/Imunizacao/CampanhaGripe/Template.vue'),
    children: [
      {
        path: '/campanha-gripe',
        component: () => import('@/pages/Imunizacao/CampanhaGripe/Index.vue'),
      },
    ],
  },
  {
    path: '/criancas-dtp-em-atraso',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Template.vue'
      ),
    children: [
      {
        path: '/criancas-dtp-em-atraso',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/pneumococica-10v',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Template.vue'
      ),
    children: [
      {
        path: '/pneumococica-10v',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/triplice-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Template.vue'),
    children: [
      {
        path: '/triplice-viral',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Index.vue'),
      },
    ],
  },
  {
    path: '/varicela',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Varicela/Template.vue'),
    children: [
      {
        path: '/varicela',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/Varicela/Index.vue'),
      },
    ],
  },
  {
    path: '/dose-imunizante',
    component: () => import('@/pages/Imunizacao/DoseImunizante/Template.vue'),
    children: [
      {
        path: '/dose-imunizante',
        component: () => import('@/pages/Imunizacao/DoseImunizante/Index.vue'),
      },
    ],
  },
  {
    path: '/tetra-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TetraViral/Template.vue'),
    children: [
      {
        path: '/tetra-viral',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/TetraViral/Index.vue'),
      },
    ],
  },
]
